/** @jsx jsx */
import { css, jsx } from "@emotion/core"
import { List } from "@cd2/components/build/es6"
import { Fields } from "@cd2/forms/build/es6"
import React from "react"

export function BarscanColumn({
  onChange,
  values,
}: {
  onChange: (newState: { buildRequired?: boolean }) => void
  values: { buildRequired?: boolean; barScanUploaded?: boolean }
}) {
  return (
    <div
      css={css`
        padding-top: 4px;
      `}
    >
      <Fields.Checkbox
        label="Build req"
        value={!!values.buildRequired}
        onChange={value => onChange({ ...values, buildRequired: !!value })}
        disabled={values.barScanUploaded}
      />
    </div>
  )
}
